import { render, staticRenderFns } from "./RolesAssignmentTable.vue?vue&type=template&id=4163f05c&scoped=true&"
import script from "./RolesAssignmentTable.vue?vue&type=script&lang=js&"
export * from "./RolesAssignmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4163f05c",
  null
  
)

export default component.exports